import initialState from './initialState'

/**
 * Replaces current Data about sale
 * @param {*} state
 * @param {*} typePayLoad
 */
const SET_TYPE = function(state, typePayLoad) {
    state.typeMessage = typePayLoad
}
/**
 *
 * @param {*} state
 * @param {title, body} message
 */
const SET_MESSAGE = function(state, message) {
    state.message.title = message.title
    state.message.body = message.body
}

const SET_PROGRESS = function(state, progress) {
    state.showProgress = progress
}

const ALIGN_TOP = function(state, payload) {
    state.alignTop = payload
}
/**
 * Hides the snackbar
 * @param {*} state
 */
const HIDE = function(state) {
    state.showSnack = false
    state.timeout = 0
}

/**
 * Shows the snackbar.
 * @param {*} state
 * @param {*} timeout Time that the snackbar remains visible. Set to 0 to remain visible indefinitely.
 */
const SHOW = function(state, timeout) {
    //commit('HIDE')
    //console.log('SHOW')
    //context('HIDE')
    state.timeout = timeout
    state.showSnack = true
    //console.log(state.showSnack)
}

const SHOW_CLOSE_BUTTON = function(state, payload) {
    state.closeOptions.show = payload.showCloseBtn
    state.closeOptions.text = payload.closeBtnMessage
}

const HIDE_CLOSE_BUTTON = function(state) {
    state.closeOptions.show = false
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET = function(state) {
    Object.assign(state, initialState())  
}

const SET_MESSAGE_CONFIRM = function(state, msg) {
    state.messageConfirm = msg
    state.enableConfirm = true
}

const RESPONSE_HAS_BEEN_CONFIRMED = function (state,identifier){
    state.responseConfirm =identifier
}

const SET_ALIGN_TOP = function(state, payload){
    //payload has to be boolean
    state.alignTop = payload
}

export default {
    SET_TYPE,
    SET_MESSAGE,
    SET_PROGRESS,
    HIDE,
    SHOW,
    SHOW_CLOSE_BUTTON,
    HIDE_CLOSE_BUTTON,
    RESET,
    SET_MESSAGE_CONFIRM,
    RESPONSE_HAS_BEEN_CONFIRMED,
    ALIGN_TOP,
    SET_ALIGN_TOP
}
